module.exports = __webpack_public_path__ + "img/soledad.110dd735.png";